import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';


import media from '../../style/mediainjector';
import {
  Section,
  FlexBox,
  H2,
  H3,
} from '@landing_academy/shared';

export const FlexSwitch = styled(FlexBox)`
  width: 100%;
  padding: 0;
  justify-content: space-between;
  ${media.lt667`
    flex-direction: column;
  `}
`;

export const CardBox = styled.div`
  width: 80%;
  max-width: 640px;
  padding: 0 0 0 30px;
  ${media.lt667`
    width: 100%;
    max-width: 100%;
    padding: 0;
    h2 {
      font-size: 2.4em;
      line-height: 1em;
    }
  `}
  a {
    color: #FFFFFF;
  }
`;

export const Image = styled.img`
  width: 25%;
  ${media.lt667`
    width: 65%;
    margin: 10px 30px 30px;
    align-self: center;
  `}
`;

const HalfBox = styled.div`
  color: white;
  color:${(props) => (props.color ? props.color : '#fff')};
  width: 50%;
  float: left;
  p {
    font-size: 0.9em;
  }
  ${media.lt480`
    width: 100%;
  `}
`;

const ContattiMl = (props) => {
  const {
    theme,
    bgColor,
    color,
    src,
  } = props;

  return (
    <Section bgColor={bgColor || theme.brand}>
      <FlexSwitch maxWidth="960px">
        <CardBox padding="0 30px 0 0">
          <H3 color={color || '#fff'} margin="0">I nostri recapiti</H3>
          <H2 color={color || '#fff'} margin="20px auto 0">Maieutical Labs</H2>
          <HalfBox color={color}>
            <p>
              <strong>Sede operativa</strong><br />
              Via Abate Vassalli Eandi, 5<br />
              10138 • Torino
            </p>
            <p><strong>Sede legale</strong><br />
              Via Pietro Regis, 26<br /> 10064 • Pinerolo (TO)
            </p>
            <p>
              <strong>Telefono</strong><br /> (+39) 011 19705073
            </p>
          </HalfBox>
          <HalfBox color={color}>
            <p>P. IVA 10623350013<br />
              C.F. e n. iscriz.<br />
              Reg. Imp. di TO<br />
              10623350013<br />
              REA: TO -1149034<br />
              PEC: maieuticallabs@legalmail.it<br />
              Capitale in bilancio: € 11.000
            </p>
          </HalfBox>
        </CardBox>
        <Image className="mediumUp" src={src.url} alt={src.alt} role="presentation" />
      </FlexSwitch>
    </Section>
  );
};

ContattiMl.propTypes = {
  theme: PropTypes.object.isRequired,
  bgColor: PropTypes.string,
  color: PropTypes.string,
  src: PropTypes.object.isRequired,
};

export default React.memo(ContattiMl);
